export default {
  getError: (state) => state.error,
  getFeedText: (state) => state.feedbackData.text,
  getFeedFilter: (state) => state.feedbackData.filter,
  getFeedRating: (state) => state.feedbackData.rating,
  getWidth: (state) => state.isMobile,
  getInternalError: (state) => state.internalServError
}
